import React, { Component, Fragment } from "react";
import Metas from "../../../Components/Educacao/Metas";

export default class PageMetas extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            unidade: this.props.match.params.unidade
        }
    }

    render() {
        let unidade = this.state.unidade === "cam" ? "citi/cam" : this.state.unidade;
        return(
            <Fragment>
                <Metas unidade={unidade}/>
            </Fragment>
        )
    }
}